import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Message, MessageType,
} from '@marageti/z4-sdk/lib/travel';
import { useSnackbar } from 'notistack';
import LogView, { ACTIONS } from './log-view';
import useChat from '../../../hooks/use-chat';

type LogContainerProps = {
  closeDialog: () => void,
  onSuccess: () => void,
  open: boolean,
  conversationId?: string,
};

const LogContainer = ({
  closeDialog,
  onSuccess,
  open,
  conversationId: conversationIdParam,
}: LogContainerProps) => {
  const { conversationId } = useParams();
  const conversationIdToUse = conversationIdParam || conversationId;
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState<Error | null>(null);

  const {
    sendMessage,
  } = useChat({
    conversationId: conversationIdToUse,
  });

  const reset = () => {
    setError(null);
  };

  const handleSubmit = async ({
    message,
    action,
  }: {
    message: string;
    action: string;
  }) => {
    reset();

    const actionObject = ACTIONS.find((a: { value: string; title: string; messageType: MessageType }) => a.value === action);

    if (!actionObject) {
      throw new Error('Invalid action');
    }

    const messageToSend: Partial<Message> = {
      conversationId: conversationIdToUse,
      text: message,
      title: actionObject.title,
      messageType: actionObject.messageType,
    };

    try {
      await sendMessage(messageToSend);
      onSuccess();
      enqueueSnackbar(actionObject.snackbarMessage, {
        variant: 'success',
      });
      closeDialog();
    } catch (e) {
      setError(e as Error);
    }
  };

  return (
    <LogView
      closeDialog={closeDialog}
      error={error}
      onSubmit={handleSubmit}
      open={open}
    />
  );
};

export default LogContainer;
